import { setupClientSideEnvironment } from '@/config/environment.client'

export default function (context, inject) {
	setupClientSideEnvironment(context)
}
